export class EmailAddressState {
  IsValid: boolean = false;
  InvalidAddresses: string = '';
}

export class EmailAddressStates {
  to: EmailAddressState = new EmailAddressState();
  cc: EmailAddressState = new EmailAddressState();
  bcc: EmailAddressState = new EmailAddressState();
}
